// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"444":"d266b228d632499710b2","663":"61a9f508b9abe6393257"}[chunkId] + ".css";
};